import { GrcNotify, NotifyType } from '@grc/ui-package';
import {
  businessEntityUrl,
  tenantService
} from '../../common/constants/url-constants';

export const getBusinessEntities = async (fetchData: any, data: any) => {
  try {
    const queryParams = new URLSearchParams();

    queryParams.append('status', data.status);

    if (data.name) {
      queryParams.append('name', data.name);
    }

    if (data.entityType) {
      queryParams.append('entityType', data.entityType);
    }

    if (data.entityIds && data.entityIds.length > 0) {
      data.entityIds.forEach((id: string) => {
        queryParams.append('entityIds', id);
      });
    }

    if (data.accountId) {
      queryParams.append('accountId', data.accountId);
    }

    if (data.locationIds && data.locationIds.length > 0) {
      data.locationIds.forEach((id: string) => {
        queryParams.append('locationIds', id);
      });
    }

    const queryString = queryParams.toString();
    const urlWithParams = `${businessEntityUrl}?${queryString}`;
    const response = await fetchData(
      urlWithParams,
      (message: any) => GrcNotify({ message, status: NotifyType.Error }),
      tenantService
    );
    if (response?.data?.length > 0) {
      return response;
    }
    return [];
  } catch (error: any) {
    GrcNotify({
      message: error.message,
      status: NotifyType.Error
    });
    return undefined;
  }
};
